import "core-js/modules/es.array.push.js";
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onClickOutside } from "@vueuse/core";
export default defineComponent({
  name: "AWelcome",
  components: {},
  props: {
    modelValue: String
  },
  emits: ["update:modelValue"],
  setup(props, {
    emit
  }) {
    const router = useRouter();
    const store = useStore();
    const showModelList = ref(false);
    const model = computed(() => {
      return store.getters.chatMode;
    });
    const hoverItem = ref();
    const quickTips = [{
      name: "论文润色",
      desc: "调整用于逻辑及语言逻辑",
      prompt: "作为一名中文学术论文写作改进助理，你的任务是改进所提供文本的拼写、语法、清晰、简洁和整体可读性，同时分解长句，减少重复，并提供改进建议，建议另起一行显示。请只提供文本的更正版本，避免包括解释。请编辑以下文本：本文论证了投资者在中国市场上投资基金，如果通过长期的投资方式或者通过定投的方式去投资，不去追涨杀跌，就不会成为庄稼手里绿油油的“韭菜”。通过这种方式，我们就可以获得长期稳定的收益。"
    }, {
      name: "爬虫程序",
      desc: "使用python编写一个爬虫程序",
      prompt: ` 使用python基于selenium框架按以下需求写一个爬虫程序。
1.爬取网站：http://www.sogou.com
2.输入关键字:[AIGC]
3.爬取标题、链接、来源
4.爬取前10页
5.爬取结果输出到Excel文件，文件命名为：AIGC_日期`
    }, {
      name: "SQL终端",
      desc: "充当示例数据库前面的SQL终端",
      prompt: `我希望您充当示例数据库前面的SQL终端。该数据库包含名为“产品”、“用户”、“订单”和“供应商”的表。我将键入查询，您将用终端显示的内容进行回复。我希望您在一个代码块中回复一个查询结果表，而不是其他内容。不要写解释。除非我指示你，否则不要键入命令。当我需要用英语告诉你一些事情时，我会用大括号{像这样｝。我的第一个命令是“从产品中选择前 10 个 * 按 ID 描述订购”`
    }, {
      name: "小红书风格",
      desc: "将文本改写成小红书的emoji风格",
      prompt: `请使用小红书的风格，帮我为小红书账号编写一份推文。要有抓人眼球的标题，每一段首带emoji ，结束有标签。账号主要发布美食相关的内容，需要突出食材、制作方法、口感等方面，吸引用户的食欲和好奇心。请确保推文有趣、有价值，能够引起用户的兴趣和共鸣，同时也能够提升账号的曝光度和用户互动率，要求不少于100字。`
    }, {
      name: "商业顾问",
      desc: "扮演商业顾问的角色",
      prompt: `现在你是我的商业顾问，我希望基于ChatGPT开发一个B2BSaas的创业项目。将内容以表格的样式进行呈现。包括:
1.创业公司名称、一个很酷，能体现AI的特点并引人注意的名字。
2.一句话描述创业的理念，需要引人注意。
3.目标用户群体及用户要解决的痛点、
4.我们的核心价值主张、销售和营销渠道、
5.计划的收入来源、成本结构、
6.关键活动、关键资源、关键合作伙伴、创意验证步骤、
7.估计的第一年运营成本
8.潜在业务挑战。`
    }, {
      name: "英语学习",
      desc: "生成题库进行练习",
      prompt: ` 我希望你能为学习英语作为第二语言的学生充当空白工作表生成器。你的任务是创建一个包含句子列表的工作表，每个句子中缺少一个单词的地方都有一个空格。学生的任务是用提供的选项列表中的正确单词填空。这些句子应该语法正确，适合英语水平中等的学生。你的工作表不应该包括任何解释或附加说明，只应该包括句子和单词选项列表。首先，请给我一个单词列表和一些句子，其中包含一个空格，有一个单词应该插入句子中。`
    }, {
      name: "研究报告",
      desc: "为您编写完整的研究报告内容",
      prompt: `请写一篇关于[人工智能]主题的研究报告。用中文回复。确保您的报告包含以下功能：
1、明确问题陈述和研究目标;
2. 对现有文献和数据进行全面分析和回顾;
3. 使用适当的方法和技术进行数据收集和分析;
4.准确的结论和建议，以回答研究问题并解决研究目标。 请保持报告简洁，结构合理，使用相关示例来说明您的观点。`
    }, {
      name: "学业辅导",
      desc: "调整用于逻辑及语言逻辑",
      prompt: `你能告诉我如何一步一步地求解一阶线性常微分方程吗？我想让你帮我解决一个问题：ty′+y=3t^2−1，t>0，其正确的答案是：y=t^2-1+c/t，但我希望您显示获得此答案的步骤`
    }];
    const text = ref("");
    const options = [{
      name: "GPT-3.5-Turbo-16k模型-免费",
      value: "GPT-3.5-Turbo-16k模型",
      desc: "我们最快的模型，非常适合大多数日常任务。.",
      reasoning: 3,
      speed: 5,
      conciseness: 2
    }, {
      name: "GPT-3.5-联网版",
      value: "GPT-3.5-联网版",
      desc: "联网查询,提供更好的帮助.",
      reasoning: 5,
      speed: 2,
      conciseness: 4
    }, {
      name: "GPT-4",
      value: "GPT-4",
      desc: "我们最强大的模型，非常适合需要创造力和高级推理的任务.",
      reasoning: 5,
      speed: 2,
      conciseness: 4
    },
    // {
    //   name: "GPT-4-备用线路1",
    //   value: "GPT-4-备用线路1",
    //   desc: "我们最强大的模型，非常适合需要创造力和高级推理的任务.",
    //   reasoning: 5,
    //   speed: 2,
    //   conciseness: 4,
    // },
    {
      name: "GPT-4-备用线路2",
      value: "GPT-4-备用线路2",
      desc: "我们最强大的模型，非常适合需要创造力和高级推理的任务.",
      reasoning: 5,
      speed: 2,
      conciseness: 4
    }, {
      name: "GPT-4-备用线路3",
      value: "GPT-4-备用线路3",
      desc: "我们最强大的模型，非常适合需要创造力和高级推理的任务.",
      reasoning: 5,
      speed: 2,
      conciseness: 4
    }, {
      name: "Claude-Instant-100k 大模型",
      value: "Claude-Instant-100k 大模型",
      desc: "我们最强大的模型，非常适合需要创造力和高级推理的任务.",
      reasoning: 5,
      speed: 2,
      conciseness: 4
    }];
    const target = ref(null);
    onClickOutside(target, () => {
      showModelList.value = false;
      hoverItem.value = null;
    });
    return {
      target,
      text,
      showModelList,
      options,
      model,
      hoverItem,
      quickTips,
      selectedModel(model) {
        store.commit("SET_CHAT_MODE", model);
        showModelList.value = false;
      },
      hover(item) {
        hoverItem.value = item;
      },
      goDraw() {
        router.push("canvas");
      },
      quickMessage(text) {
        emit("update:modelValue", text);
      },
      download() {
        const filename = "云雾AI.url";
        const urlContent = `[InternetShortcut]
URL=${location.href}`;
        const blob = new Blob([urlContent], {
          type: "text/plain"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 100);
      }
    };
  }
});